import React from 'react'
import PropTypes from 'prop-types'
import InputLabel from '../../../typography/Input/InputLabel'
import styled from 'styled-components'
import colors from '../../../../configuration/colors'
import Input from '../../../typography/Input'

const SelectorContainer = styled.div`
  position: relative;
`
const Text = styled(Input)`
  font-family: Roboto;
  letter-spacing: 0;
`

export const StaticInputValue = ({
  placeholder,
  textValue
}) => {
  return (
    <SelectorContainer>
      <InputLabel>
        {placeholder}
      </InputLabel>
      <Text>
        {textValue}
      </Text>
    </SelectorContainer>
  )
}

StaticInputValue.propTypes = {
  placeholder: PropTypes.string.isRequired,
  textValue: PropTypes.string.isRequired
}

export default StaticInputValue



// WEBPACK FOOTER //
// ./src/components/modal/CreateOrEditCourseModal/InputComponents/StaticInputValue.js